import { gql } from '@apollo/client';

export const POSITION_FIELDS = gql`
  fragment PositionFields on Position {
    positionId
    jobId
    staffId
  }
`;
